module.exports = __webpack_public_path__ + "img/1571641143.d8e927f7.jpg";